angular.
module("dx.webapp.invigilator").
component("dxInvigilator", {
	templateUrl: "tmpl/invigilator/invigilator-component.html",
	controller: "DxInvigilatorController",
	controllerAs: "vm",
	bindings: {
		examId: "=",
		doSave: "=",
		saveCallbackFunction: "=",
		location: "<",
	},
});
